<template>
  <v-chart :options="chartOp" :autoresize="true"></v-chart>
</template>

<script>
import { bm4000Bar } from '@/echartOption/bm4000';

export default {
  props: {
    op: {
      type: Object,
      default: () => {}
    },
    minParticle: {
      type: String,
      default: '0.5'
    }
  },
  computed: {
    chartOp() {
      return bm4000Bar(this.op, this.minParticle);
    }
  }
};
</script>
